module.exports = __webpack_public_path__ + "08db97a723f8f939091fcf2048de3b68.png";